import { GradeLevel, LearningStage } from '@suntex.fim/enums';
import { ModuleTagging } from '@suntex.fim/framework';

function getModuleKey(slug: string, variant: number | undefined): string {
  return `${slug}:${variant ?? 0}`;
}

/**
 * Returns a predicate matching the modules (by slug and variant) in a Stages
 * of Learning stage for a grade level. Mirrors the hub's SoL stage filter
 * path (`grade:{level}/sol:{stage}`).
 */
export function buildLearningStageModuleMatcher(
  moduleTagging: readonly ModuleTagging[],
  gradeLevel: GradeLevel,
  stage: LearningStage,
): (slug: string, variant: number | undefined) => boolean {
  const filterTagPath = `grade:${gradeLevel}/sol:${stage}`;
  const keys = new Set(
    moduleTagging
      .filter((t) => t.tag.path.startsWith(filterTagPath))
      .map((t) => getModuleKey(t.module.slug, t.module.variant)),
  );
  return (slug, variant) => keys.has(getModuleKey(slug, variant));
}
